import script from "./DebugBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugBar.vue?vue&type=script&setup=true&lang=js"

import "./DebugBar.vue?vue&type=style&index=0&id=5cf5edcb&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf5edcb"]])

export default __exports__